import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../../utils/decorators";


@Options({
    template: require("../templates/made-off-sale.njk"),
})
export default class MadeOffSale extends Marionette.View<Backbone.Model>{

}



// WEBPACK FOOTER //
// ./@modules/button-logic/views/made-off-sale.ts